import classNames from 'classnames';

import { publicAsset } from '../../../utils/publicAsset';
import styles from './styles.module.scss';

/**
 * The 5-avatar cluster illustration shown on the waitlist page and the promo
 * modal. HORO-10471.
 *
 * Images and geometry both come from Figma node 4481:20887 ("Group 2956" — a
 * 202x190 box holding five 65px circles). Offsets are percentages of that box
 * so the cluster scales with its container instead of being pinned to one
 * breakpoint.
 *
 * The files are position-named rather than advisor-named on purpose: these are
 * flat art assets lifted from the design, not the live advisor roster. Naming
 * them after real advisors would imply a line-up for a feature that doesn't
 * exist yet, and would rot the moment the roster changes.
 *
 * Exported as JPEG (196px, q90, ~10KB each). The source PNGs were 48-63KB;
 * transparency isn't needed because `.clusterAvatar` clips to a circle with
 * border-radius, so the corners never render.
 */
const CLUSTER = [
    { file: 'top', left: '33.72%', top: '0%' },
    { file: 'right', left: '67.76%', top: '25.75%' },
    { file: 'left', left: '0%', top: '25.75%' },
    { file: 'bottom-left', left: '12.14%', top: '65.81%' },
    { file: 'bottom-right', left: '56.65%', top: '65.81%' }
];

const AvatarCluster = ({ className }) => (
    <div className={classNames(styles.cluster, className)} aria-hidden="true">
        {CLUSTER.map(({ file, left, top }) => (
            <img
                key={file}
                className={styles.clusterAvatar}
                style={{ left, top }}
                src={publicAsset(`/image/live-readings/advisor-${file}.jpg`)}
                alt=""
            />
        ))}
    </div>
);

export default AvatarCluster;
